import React from 'react';
import { showEmeraldDialog } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { ILineItemAddData } from 'src/items-list/business-logic/line-item-add';
import { useTranslation } from 'react-i18next';
import { styles } from './online-item-id-modal-styles';
import { Grid, Typography } from '@material-ui/core';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import barcode from 'src/item-list/media/barcode.svg';
import { convertUnitPriceCurrency } from 'src/common/helpers/currency-helper';
import clsx from 'clsx';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';

const SHOW_SWIPE_MODAL = 'show-swipe-modal';

type Props = SwipeCardOnlineItemModalProps;

export const showSwipeCardOnlineItemModal = (props: Props): void => {
  swipeCardOnlineItemModal(props);
};

export const closeSwipeCardOnlineItemModal = () => {
  popEmeraldModal(SHOW_SWIPE_MODAL);
};
export const TextContent = (props): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();
  const itemPrice = props.lineItemData.itemLookup.regularSalesUnitPrice?.price;
  const unitPrice = convertUnitPriceCurrency(itemPrice?.value || 0, itemPrice?.currency).split('/');
  return (
    <Grid container justifyContent='center' direction='column'>
      <Grid>
        <Typography
          variant='h2'
          data-testid='swipe-online-title-text'
          className={`${classes.authorizeTitle} ${classes.swipeAuthorizeTitlePad}`}
        >
          {t('OnlineItemActivation_Title')}
        </Typography>
      </Grid>
      <Grid container className={classes.barPadding}>
        <div className={clsx(classes.barError, classes.bar)} />
      </Grid>
      <Grid>
        <Typography
          data-testid='swipe-online-item-id-text'
          variant='body1'
          className={classes.swipeCardText}
        >
          {t('OnlineItemActivation_SwipeMessage')}
        </Typography>
      </Grid>
      <Grid
        container
        data-testid='barcode-pinpad-icon-container'
        className={classes.swipeIconContainer}
      >
        <Grid className={classes.imageContainer}>
          <img src={barcode} alt='Barcode' />
        </Grid>
      </Grid>
      <Grid className={`${classes.itemContainer} ${classes.swipeItemContainerPad}`}>
        <Typography variant='h6' className={classes.darkText} data-testid='swipe-item-description'>
          {props.lineItemData.itemLookup.description}
        </Typography>
        {itemPrice?.value && (
          <Grid className={classes.swipePriceContainer}>
            <Typography variant='h6' className={classes.darkText} data-testid='swipe-item-price'>
              {unitPrice[0]}
            </Typography>
            <Typography variant='body2' className={classes.itemUnit} data-testid='swipe-item-unit'>
              {`/ ${unitPrice[1]}`}
            </Typography>
          </Grid>
        )}
      </Grid>
      <Typography
        variant='body1'
        className={`${classes.swipeItemId} ${classes.swipeItemContainerPad}`}
      >
        {props.lineItemData.itemLookup.itemId}
      </Typography>
    </Grid>
  );
};

export const swipeCardOnlineItemModal = (props: SwipeCardOnlineItemModalProps): void => {
  const modalConfig: IMessageModal = {
    modalId: SHOW_SWIPE_MODAL,
    title: 'OnlineItem',
    hideAcceptButton: true,
    separateButton: true,
    onCancel: props.onClose,
    textContent: <TextContent {...props} />,
    type: EmeraldDialogTypes.Warning,
    dialogHeight: 78.65,
    dialogWidth: 46.86,
  };

  showEmeraldDialog(modalConfig);
};

export interface SwipeCardOnlineItemModalProps {
  lineItemData: ILineItemAddData;
  onClose: () => void;
}
